<script>
import { brand } from "@/helpers/brand";
import { hasSelectedProject } from "@/helpers/companySession";
import AppLayout from "@/router/layouts/app-layout";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  components: { AppLayout },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${brand.title}` : brand.title;
    },
  },
  data() {
    return {
      // El guard del router ya corrió: una pestaña nueva llega acá con el último
      // proyecto de su cuenta, si había uno (ver helpers/companySession).
      hasProject: hasSelectedProject(),
    };
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  computed: {
    // El layout vive acá y no dentro de cada vista: se monta una vez y sobrevive
    // a la navegación. Solo se desmonta al pasar a una ruta con `layout: false`.
    withLayout() {
      const matched = this.$route.matched;
      return matched.length > 0 && matched.every((route) => route.meta.layout !== false);
    },
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
      this.hasProject = hasSelectedProject();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
  <div id="app">
    <notifications position="bottom right" classes="my-notification"/>
    <AppLayout v-if="withLayout">
      <!-- Sin proyecto no se monta ninguna pantalla: todas consultan con el
           proyecto de la pestaña y sin él solo fallarían (y reintentarían)
           detrás del selector de proyecto que el nav-bar tiene abierto. -->
      <RouterView v-if="hasProject" />
    </AppLayout>
    <RouterView v-else />
  </div>
</template>

<style lang="scss">

// Barra de carga de pantallas (la crea router/index.js en <body>).
.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: #5e40bf;
  box-shadow: 0 0 6px rgba(94, 64, 191, 0.5);
  opacity: 0;
  pointer-events: none;
  z-index: 2000;

  &.is-loading {
    opacity: 1;
    width: 85%;
    transition: width 8s cubic-bezier(0.1, 0.7, 0.3, 1);
  }

  &.is-done {
    width: 100%;
    opacity: 0;
    transition: width 0.2s ease, opacity 0.25s ease 0.2s;
  }
}

.my-notification {
  
  margin: 10px;
  margin-bottom: 0;
  border-radius: 3px;
  font-size: 13px;
  padding: 10px 20px;
  border: 1px solid #D4E8FD;

  .notification-title {
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 10px;    
  } 
  

  &.success {
    background: #d6f3e9;
    border-left-color: #c2eddd;
    color: #1f7556 !important;
  }

  &.warn {
    background: #fcf0db;
    border-left-color: #fbe9c9;
    color: #916c2e !important;
  }

  &.error {
    background: #fde1e1;
    border-left-color: #fcd2d2;
    color: #924040 !important;
    
  }
}
</style>
